import React, { useContext } from 'react';
import classes from './RightDrawer.module.scss';
import { SquareButton } from '../../components/actions/SquareButton';
import { SquareButtonIconsEnum } from '../../constants/square-button-icons';
import { AppContext } from '../../providers/AppProvider';
import { RightDrawerTypeEnum } from '../../constants/right-drawer';
import { Notifications } from './Notifications';
import { Settings } from './Settings';
import { Help } from './Help';
import { useSelectedOrganization } from '../../hooks/useSelectedOrganization';
import { OutsideClickWrapper } from '../../components/actions/OutsideClickWrapper';

export type RightDrawerViewProps = {
  onCloseAttempt: VoidFunction;
  onClose: VoidFunction;
};

export const RightDrawerView = React.forwardRef<HTMLDivElement, RightDrawerViewProps>((props, ref): JSX.Element => {
  const { selectedOrganization } = useSelectedOrganization();
  const { rightDrawerState } = useContext(AppContext);

  return (
    <OutsideClickWrapper
      onClickOutside={props.onCloseAttempt}
      onFocusOutside={props.onCloseAttempt}
      className={classes.RightDrawer}
      ref={ref}>
      <div className={`grid-x align-justify ${classes.RightDrawerHeader}`}>
        {rightDrawerState.title && (
          <div className={classes.RightDrawerHeaderTitle}>
            <h4>{rightDrawerState.title}</h4>
          </div>
        )}
        <div className={classes.RightDrawerCloseButton}>
          <SquareButton type={'transparent'} icon={SquareButtonIconsEnum.close} action={props.onClose} />
        </div>
      </div>
      {((): JSX.Element | null => {
        switch (rightDrawerState.type) {
          case RightDrawerTypeEnum.notifications:
            return selectedOrganization ? <Notifications selectedOrganizationId={selectedOrganization.id} /> : <></>;
          case RightDrawerTypeEnum.settings:
            return <Settings closeAction={props.onClose} />;
          case RightDrawerTypeEnum.help:
            return <Help />;
          default:
            return null;
        }
      })()}
    </OutsideClickWrapper>
  );
});

RightDrawerView.displayName = 'RightDrawerView';
